// AI分析用
export const getAIStatusName = (num) => {
  switch (num) {
    case "0":
      return "無効";
    case "1":
      return "有効";
    case "2":
      return "臥床";
    case "3":
      return "長座位";
    case "4":
      return "端座位";
    case "5":
      return "離床";
    case "6":
      return "転倒";
    default:
      return "";
  }
};